/** SMALL TASKS SERVICES * SMALL TASKS SERVICES * SMALL TASKS SERVICES */


// CREATE a Small Task
async function addSmallTaskToToday(uId, token, today, task) {
  // return true if create is successful, or throws error.

  // build data
  const smallTask = { ...task };

  // API call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/days/${uId}/${today}/smalltasks.json?auth=${token}`, {
    method: 'POST',
    body: JSON.stringify(smallTask),
  });
  if (!response.ok) {
    throw new Error(response.message || 'Failed to add one Small Task to today');
  } else {
    return true;
  }
}



// READ All Small Tasks
async function getAllSmallTasksFromDbase(uId, token, today) {
  // returns an array of tasks, or empty array

  // console.log('*** starting getAllSmallTasksFromDbase(uId, token, today) ***', uId, token, today);
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/days/${uId}/${today}/smalltasks.json?auth=${token}`);
  const responseData = await response.json();
  // console.log('*** getAllSmallTasksFromDbase() >>> got todaysSmallTasks from dbase ***', responseData);

  // err handling
  if (!response.ok) {
    throw new Error(response.message || 'Failed to get today\'s Small Tasks');
  }

  // format the Small Tasks
  let smallTasks = [];
  for (const key in responseData) {
    const oneSmallTask = {
      id: key,
      task: responseData[key].task,
      stacked: responseData[key].stacked,
      dateCreated: responseData[key].dateCreated,
      dateUpdated: responseData[key].dateUpdated,
    };
    smallTasks.push(oneSmallTask);
  }

  // send it back
  return smallTasks;
}


// READ One single Small Task (by id)
async function getOneSmallTaskFromDbase(uId, token, today, taskId) {
  // returns a single Small Task object, or throws error
  // console.log('*** starting getOneSmallTaskFromDbase(uId, token, today, taskId) ****', uId, token, today, taskId);

  // API call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/days/${uId}/${today}/smalltasks/${taskId}.json?auth=${token}`);
  const responseData = await response.json();
  console.log('*** getOneSmallTaskFromDbase() >>> got single Small Task from dbase ***', responseData);

  if (!response.ok) {
    throw new Error(response.message || 'Failed to get from dbase, a single Small Task for today');
  }

  // const singleSmallTask = {
  //   id:
  // };
}


// UPDATE One Small Task
async function updateASmallTask(uId, token, today, taskId, smallTask) {
  // return true if update is successful, or error.

  const updatedTask = {
    task: smallTask.task,
    stacked: smallTask.stacked,
    dateCreated: smallTask.dateCreated,
    dateUpdated: smallTask.dateUpdated,
  };

  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/days/${uId}/${today}/smalltasks/${taskId}.json?auth=${token}`, {
    method: 'PATCH',
    body: JSON.stringify(updatedTask),
  });
  console.log('*** about to updateASmallTask(taskId, task) ***', taskId, updatedTask, response.json());

  if (!response.ok) {
    throw new Error(response.message || 'Failed to update a single Small Task');
  }
  return true;
  // let t = { ...updatedTask };
  // t.id = taskId;
  // return t;

}

// DELETE A WIN - return true if delete is successful, or error.
async function deleteASmallTask(uId, token, today, taskId) {

  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/days/${uId}/${today}/smalltasks/${taskId}.json?auth=${token}`, {
    method: 'DELETE',
  });
  const responseData = await response.json();

  if (!response.ok) { 
    // console.log(responseData);
    throw new Error(response.message || 'Failed to delete a Small Task');
  } else {
    return responseData;
  }
}

export { addSmallTaskToToday, getAllSmallTasksFromDbase, getOneSmallTaskFromDbase, updateASmallTask, deleteASmallTask };
